import { colorsConfig } from "../config/colors.config";

export const connectBusinessFlowColors = {
  surface: "#ffffff",
  band: colorsConfig.cardBg,
  text: colorsConfig.textPrimary,
  muted: colorsConfig.textSecondary,
  accent: colorsConfig.iconPrimary,
  accentDark: "#b4641e",
  border: "var(--fx-surface-border, #E2E8F0)",
};

export const connectBusinessFlowSx = {
  shell: {
    p: { xs: 2, md: 3 },
    width: "100%",
    minHeight: { xs: "auto", md: 500 },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  panel: {
    width: "100%",
    p: { xs: 2.5, md: 4 },
    borderRadius: "3px",
    backgroundColor: connectBusinessFlowColors.surface,
    border: `1px solid ${connectBusinessFlowColors.border}`,
    boxShadow: "none",
  },
  contentBand: {
    p: { xs: 2, md: 3 },
    backgroundColor: connectBusinessFlowColors.band,
    borderRadius: "3px",
    border: `1px solid ${connectBusinessFlowColors.border}`,
  },
  iconWrap: {
    width: 48,
    height: 48,
    backgroundColor: `${connectBusinessFlowColors.accent}25`,
    color: connectBusinessFlowColors.accent,
    mx: "auto",
    mb: 2,
  },
  title: {
    color: connectBusinessFlowColors.text,
    fontWeight: 700,
    letterSpacing: 0,
  },
  copy: {
    color: connectBusinessFlowColors.muted,
    lineHeight: 1.6,
  },
  primaryButton: {
    px: 3,
    py: 1,
    borderRadius: "3px",
    backgroundColor: connectBusinessFlowColors.accent,
    color: "#ffffff",
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: connectBusinessFlowColors.accentDark,
      boxShadow: "none",
    },
  },
  secondaryButton: {
    px: 3,
    py: 1,
    borderRadius: "3px",
    color: connectBusinessFlowColors.text,
    borderColor: connectBusinessFlowColors.border,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      borderColor: connectBusinessFlowColors.text,
      backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    },
  },
};
